import { FinancialOperationService } from '@hub/shared'
import { useCallback, useEffect, useMemo, useState } from 'react'

export interface Amount {
  hideValue?: boolean
  amount?: number
  qtdCampaigns?: number
}

export interface IAmount {
  state: Amount
  setState: (newState: Amount | any) => void
}

const useAmounts = () => {
  const financialOperationService = useMemo(() => new FinancialOperationService(), [])
  const [state, setState] = useState<Amount>({ amount: 0, qtdCampaigns: 0 })

  const getAmounts = useCallback(async () => {
    try {
      // Os status abaixo são os que não serão carregados no Amount
      const response = await financialOperationService.getAmountsReceived([
        'new',
        'pending',
        'analyze',
        'review',
        'readyToPay',
        'withdrawing',
        'canceled',
        'retry',
        'blocked',
        'unblocked',
        'failed',
      ])
      if (response?.uniqueStatus?.length) {
        setState((prevState) => ({
          ...prevState,
          amount: response?.totals?.totalGrossValue,
          qtdCampaigns: response?.totals?.totalCampaigns,
        }))
      } else {
        setState((prevState) => ({
          ...prevState,
          amount: 0,
          qtdCampaigns: 0,
        }))
      }
    } catch (err) {
      setState((prevState) => ({
        ...prevState,
        amount: 0,
        qtdCampaigns: 0,
      }))
    }
  }, [financialOperationService])

  useEffect(() => {
    getAmounts()
  }, [getAmounts])

  return { state, setState } as IAmount
}

export default useAmounts
